module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Sửa danh mục bài viết",
      "breadcrumbs": [{
        title: 'Quản lý danh mục bài viết',
        route: {
          name: 'category'
        }
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-all"
  }, [_c('el-form', {
    ref: "editCategoryForm",
    attrs: {
      "model": _vm.localCategory,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitCategory('editCategoryForm')
      }
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên danh mục bài viết",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên danh mục bài viết"
    },
    model: {
      value: (_vm.localCategory.name),
      callback: function($$v) {
        _vm.$set(_vm.localCategory, "name", $$v)
      },
      expression: "localCategory.name"
    }
  })], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Kiểu danh mục",
      "prop": "type"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Kiểu danh mục"
    },
    on: {
      "change": _vm.getCategories
    },
    model: {
      value: (_vm.localCategory.type),
      callback: function($$v) {
        _vm.$set(_vm.localCategory, "type", $$v)
      },
      expression: "localCategory.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "Chọn kiểu danh mục",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.categoryHelpers.types), function(type, key, index) {
    return (_vm.categoryHelpers.types) ? _c('el-option', {
      key: index,
      attrs: {
        "label": type,
        "value": key
      }
    }) : _vm._e()
  })], 2)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Chọn danh mục",
      "prop": "parent_id"
    }
  }, [_c('el-select', {
    staticClass: "width-100",
    attrs: {
      "filterable": "",
      "placeholder": "Chọn danh mục"
    },
    model: {
      value: (_vm.localCategory.parent_id),
      callback: function($$v) {
        _vm.$set(_vm.localCategory, "parent_id", $$v)
      },
      expression: "localCategory.parent_id"
    }
  }, _vm._l((_vm.categories), function(category) {
    return _c('el-option', {
      key: category.id,
      attrs: {
        "label": category.name,
        "value": category.id
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "Trạng thái",
      "prop": "active"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.localCategory.active),
      callback: function($$v) {
        _vm.$set(_vm.localCategory, "active", $$v)
      },
      expression: "localCategory.active"
    }
  }, _vm._l((_vm.categoryHelpers.statuses), function(status, key, index) {
    return _c('el-radio', {
      key: key,
      staticClass: "radio",
      attrs: {
        "label": key
      }
    }, [_vm._v(_vm._s(status))])
  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-13c28b87"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/category/EditCategory.vue
// module id = 695
// module chunks = 1